module.exports = __webpack_public_path__ + "img/top-10-calendar.93e45c43.webp";